import React from "react";
import { useNavigate } from "react-router-dom";
import { Play, Clock } from "lucide-react";
import { imgUrl } from "../lib/api";

export const EpisodeCard = ({ episode, showSeries = false, active = false, index = 0 }) => {
  const navigate = useNavigate();
  const thumb = episode.thumbnail_url;
  return (
    <button
      onClick={() => navigate(`/watch/${episode.id}`)}
      data-testid={`episode-card-${episode.id}`}
      style={{ animationDelay: `${index * 50}ms` }}
      className={`group flex gap-3 w-full text-left rounded-lg p-2 transition-colors duration-200 animate-fade-up ${
        active ? "bg-blood/15 border border-blood/40" : "hover:bg-white/5 border border-transparent"
      }`}
    >
      <div className="relative shrink-0 w-36 sm:w-44 aspect-video overflow-hidden rounded-md bg-[#0A0A0A] border border-white/5">
        {thumb ? (
          <img src={imgUrl(thumb)} alt={episode.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-white/20 text-xs">No thumbnail</div>
        )}
        <div className="absolute inset-0 flex items-center justify-center bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity">
          <Play size={28} className="fill-white text-white drop-shadow-[0_0_10px_rgba(220,20,60,0.8)]" />
        </div>
        {episode.duration && (
          <span className="absolute bottom-1 right-1 text-[10px] font-semibold bg-black/80 px-1.5 py-0.5 rounded flex items-center gap-1">
            <Clock size={10} /> {episode.duration}
          </span>
        )}
      </div>
      <div className="min-w-0 flex-1 py-0.5">
        <p className="text-[11px] font-bold tracking-widest uppercase text-blood">
          {showSeries && episode.series_title ? episode.series_title : `S${episode.season_number} · E${episode.episode_number}`}
        </p>
        <p className="text-sm font-semibold text-white truncate group-hover:text-blood transition-colors">{episode.title}</p>
        <p className="text-xs text-white/50 line-clamp-2 mt-0.5">{episode.description}</p>
      </div>
    </button>
  );
};
